
import { NavigationGuardNext, RouteLocationNormalizedGeneric, RouteLocationNormalizedLoadedGeneric, RouteRecordRaw } from 'vue-router'
import packageConfig from '../../package.json'
import { indexDBStore, qiankunStore, appStore } from '@/store/index'
import { hasSlashInPatch } from '@/utils'

window.__PORTAL_VERSION__ = packageConfig.version

export default {
  getVersion: () => {
    return packageConfig.version
  },
  // 提供全局indexDB对象
  getIndexDB: () => {
    const useIndexDBStore = indexDBStore()
    return useIndexDBStore.IndexDB
  },
  // 提供全局微应用列表
  getMicroAppsList: () => {
    const useQiankunStore = qiankunStore()
    return useQiankunStore.microApps
  },
  // 提供隐藏主框架侧边栏方法
  setSiderBarVisiable(visiable:boolean) {
    const useAappStore = appStore()
    useAappStore.setSiderBarVisible(visiable)
  },
  // 提供全局使用vue-router 4.x微应用跳转逻辑
  globalVueRouter: (microName: string, to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedLoadedGeneric, next: NavigationGuardNext) => {
    // if (!history.state.back) history.state.back = from.fullPath
    // if (!history.state.current) history.state.current = window.location.pathname
    // if (!location.href.includes(microName)) {
    //   return history.replaceState({ back: from.fullPath, current: window.location.pathname }, '', window.location.pathname)
    // }
    next()
  },
  // 处理路由path和name的映射
  pathToName(baseMicroName = '', router: RouteRecordRaw[], baseName = 'portal') {
    const nameArr: { path: string, name: string | symbol} [] = []
    const recursionName = (list: RouteRecordRaw[], fatherPath = '') => {
      fatherPath = fatherPath.split('/portal')[1] || fatherPath
      list.forEach(item => {
        if (item.children) {
          recursionName(item.children as RouteRecordRaw[], hasSlashInPatch([baseName, fatherPath, item.path]))
        } else {
          nameArr.push({
            path: fatherPath ? hasSlashInPatch([baseName, baseMicroName, fatherPath, item.path]) : hasSlashInPatch([baseName, baseMicroName, item.path]),
            name: item.name || ''
          })
        }
      })
    }
    recursionName(router)
    return nameArr.filter(item => item.path !== `/${baseName}/${baseMicroName}`)
  }
}
